import { create } from 'zustand';
import { getErrorMessage } from '@/shared/lib/errors';
import { chatEditHistoryService } from '../api/chatEditHistoryService';
import type { ChatEditHistoryState, ChatEditHistoryActions } from './types';

/** Хранит страницы правок и отклоняет ответы после закрытия окна */
export const createEditHistoryStore = (
    dialogId: string,
    messageId: string,
    ownerAppUserId?: string
) => {
    let revision = 0;

    return create<ChatEditHistoryState & ChatEditHistoryActions>((set, get) => ({
        items: [],
        loading: false,
        loaded: false,
        error: null,
        beforeVersion: undefined,
        hasMore: false,

        load: async () => {
            if (get().loading) return;
            const current = ++revision;
            const beforeVersion = get().beforeVersion;

            set({
                loading: true,
                error: null
            });

            try {
                const page = await chatEditHistoryService.get({
                    dialogId,
                    messageId,
                    ownerAppUserId,
                    beforeVersion
                });

                if (current !== revision) return;

                set((state) => ({
                    items: [...state.items, ...page],
                    beforeVersion: page[page.length - 1]?.version,
                    hasMore: page.length === 50 && (page[page.length - 1]?.version ?? 0) > 1,
                    loading: false,
                    loaded: true,
                }));
            } catch (error: unknown) {
                if (current === revision) set({
                    loading: false,
                    error: getErrorMessage(error, 'Не удалось загрузить историю правок')
                });
            }
        },

        reset: () => {
            revision += 1;

            set({
                items: [],
                loading: false,
                loaded: false,
                error: null,
                beforeVersion: undefined,
                hasMore: false
            });
        },
    }));
};
